module.exports = __webpack_public_path__ + "img/amc_services.ae2bb94f.png";